import getConfig from 'next/config';

const {
  publicRuntimeConfig: {
    GF_DOTCOM_USER_SERVICE_ENDPOINT
  },
} = getConfig();

const endpoint = GF_DOTCOM_USER_SERVICE_ENDPOINT || '';

const getNavbarConfig = (featureFlags = {}) => ({
  routes: [
    {
      text: 'Home',
      url: '/',
      local: true,
      logoLink: true,
    },
    {
      text: 'Products',
      url: '/products',
      local: true,
    },
    {
      text: 'Reviews',
      url: '/reviews',
      local: true,
      disabled: !!featureFlags['reviews-nav-disabled'],
    },
    {
      text: 'Watch',
      url: '/watch',
      local: true,
    },
    {
      text: 'EDU',
      url: 'https://education.glowforge.com/',
    },
    {
      text: 'FAQ',
      url: '/faq',
      local: true,
    },
    {
      text: 'Community',
      url: 'https://community.glowforge.com',
    },
    {
      text: 'Gallery',
      url: '/discover',
    },
  ],
  userRoutes: {
    referrals: {
      local: false,
      text: 'Referrals',
      url: '/referrals',
      type: 'signed-in',
    },
    login: {
      local: false,
      text: 'Sign In',
      url: `${endpoint}/users/sign_in`,
    },
    settings: {
      local: false,
      text: 'Settings',
      url: '/settings',
      type: 'signed-in',
    },
    logout: {
      local: false,
      text: 'Sign Out',
      url: `${endpoint}/users/sign_out`,
      type: 'signed-in',
    },
  },
  userSecondaryLinks: [{
    local: false,
    text: 'Referrals',
    url: '/referrals',
  }],
});

export default getNavbarConfig;
